export var HdsIconlibraryFile_16px;
(function (HdsIconlibraryFile_16px) {
    HdsIconlibraryFile_16px["ArchiveSolid_16px"] = "archive_solid_16px";
    HdsIconlibraryFile_16px["CopySolid_16px"] = "copy_solid_16px";
    HdsIconlibraryFile_16px["DocFileSolid_16px"] = "DOC-File_solid_16px";
    HdsIconlibraryFile_16px["EpsFileSolid_16px"] = "EPS-File_solid_16px";
    HdsIconlibraryFile_16px["FileSolid_16px"] = "file_solid_16px";
    HdsIconlibraryFile_16px["GifFileSolid_16px"] = "GIF-File_solid_16px";
    HdsIconlibraryFile_16px["HtmlFileSolid_16px"] = "HTML-File_solid_16px";
    HdsIconlibraryFile_16px["ImageSolid_16px"] = "image_solid_16px";
    HdsIconlibraryFile_16px["JpgFileSolid_16px"] = "JPG-File_solid_16px";
    HdsIconlibraryFile_16px["JsonFileSolid_16px"] = "JSON-File_solid_16px";
    HdsIconlibraryFile_16px["Mp3FileSolid_16px"] = "MP3-File_solid_16px";
    HdsIconlibraryFile_16px["PdfFileSolid_16px"] = "PDF-File_solid_16px";
    HdsIconlibraryFile_16px["PngFileSolid_16px"] = "PNG-File_solid_16px";
    HdsIconlibraryFile_16px["SvgFileSolid_16px"] = "SVG-File_solid_16px";
    HdsIconlibraryFile_16px["TiffFileSolid_16px"] = "TIFF-File_solid_16px";
    HdsIconlibraryFile_16px["TxtFileSolid_16px"] = "TXT-File_solid_16px";
    HdsIconlibraryFile_16px["WavFileSolid_16px"] = "WAV-File_solid_16px";
    HdsIconlibraryFile_16px["ZipSolid_16px"] = "ZIP_solid_16px";
})(HdsIconlibraryFile_16px = HdsIconlibraryFile_16px || (HdsIconlibraryFile_16px = {}));
export const HDS_ICONLIBRARY_FILE_16PX_CODEPOINTS = {
    [HdsIconlibraryFile_16px.ArchiveSolid_16px]: '61697',
    [HdsIconlibraryFile_16px.CopySolid_16px]: '61698',
    [HdsIconlibraryFile_16px.DocFileSolid_16px]: '61699',
    [HdsIconlibraryFile_16px.EpsFileSolid_16px]: '61700',
    [HdsIconlibraryFile_16px.FileSolid_16px]: '61701',
    [HdsIconlibraryFile_16px.GifFileSolid_16px]: '61702',
    [HdsIconlibraryFile_16px.HtmlFileSolid_16px]: '61703',
    [HdsIconlibraryFile_16px.ImageSolid_16px]: '61704',
    [HdsIconlibraryFile_16px.JpgFileSolid_16px]: '61705',
    [HdsIconlibraryFile_16px.JsonFileSolid_16px]: '61706',
    [HdsIconlibraryFile_16px.Mp3FileSolid_16px]: '61707',
    [HdsIconlibraryFile_16px.PdfFileSolid_16px]: '61708',
    [HdsIconlibraryFile_16px.PngFileSolid_16px]: '61709',
    [HdsIconlibraryFile_16px.SvgFileSolid_16px]: '61710',
    [HdsIconlibraryFile_16px.TiffFileSolid_16px]: '61711',
    [HdsIconlibraryFile_16px.TxtFileSolid_16px]: '61712',
    [HdsIconlibraryFile_16px.WavFileSolid_16px]: '61713',
    [HdsIconlibraryFile_16px.ZipSolid_16px]: '61714',
};
//# sourceMappingURL=hds-iconlibrary-file-16px.js.map